// extracted by mini-css-extract-plugin
export default {"form":"login_form__OBGEf","error":"login_error__Cse+h"};